import {Component, ElementRef, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/services/api.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject, Subscription, interval, timer } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-pnr-flight-form',
  templateUrl: './pnr-flight-form.component.html',
  styleUrls: ['./pnr-flight-form.component.css']
})
export class PnrFlightFormComponent implements OnInit, OnDestroy {
  sessionid: any;
  ismobile;
  nextgate: any[];
  index=0;
  constructor(private route: ActivatedRoute,private router: Router,private apiService: ApiService ,public dialog: MatDialog, private devicedetails: DeviceDetectorService, private apiservice : ApiService) {
    this.ismobile = this.devicedetails.isMobile();
    this.checkinternetissue();
   }
  flightNo: any = '';
  ref: MatDialogRef<any>;
  @ViewChild("DialogComponent", { read: TemplateRef, static: false }) DialogComponent: TemplateRef<any>;
  datamessage = '';
  spinner:boolean = false;
  isPortrait:boolean;
  SearchLoader:boolean = false;
  nodatamessage:boolean = false;
  dataarray:[] = []
  allflightdata:[] = []
  langconfig;
  showvideo:boolean = true;
  homescreenimage;
  image;
  isvideo:boolean = false;
  gateslist= [];
  demo:boolean = true;
  data;
  gatesdata : {}[]=[];
  gatesdata1;
  videotag;
  nextgatevalue;
  callgates1;
  source;
  device;
  medium;
  dummypercentages = ['13', '16', '20', '24'];
  apicalled:boolean = false;
  qrimage;
  dummyarray = [{ text: 'Flight' }, { text: 'Gate' }, { text: 'Destination' }];
  userStop$: Subject<boolean> = new Subject<boolean>();
  apiTrigger$: Subject<boolean> = new Subject<any>();
  currentIndex: number = 0;
  isDeleting: boolean = false;
  charIndex: number = 0;
  autotype:boolean = true;
  calltextfunction;
  deletetext;
  form: FormGroup;
  @ViewChild('inputElement',{static:false}) inputElementRef: ElementRef;
  lastInput: HTMLInputElement;
  cursorPosition: number = 0;
  callinterval: any;
  starttimeout;
  calltimer1:Subscription;
  calltimer2:Subscription;
  animationFrameId: number;
  isDestroyed:boolean = false;
  languagesub:Subscription;
  showvideosub:Subscription;
  startProgress() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
    const interval = 15000;
    this.nextgatevalue = 0;
    let startTime: number;
      const updateProgress = (currentTime: number) => {
        if (!startTime) {
          startTime = currentTime;
        }
        const elapsedTime = currentTime - startTime;
        if (elapsedTime >= interval) {
          this.nextgatevalue = 0;
          startTime = currentTime;
        } else {
          this.nextgatevalue = Math.floor((elapsedTime / interval) * 100);
        }
        if (!this.isDestroyed) {
          this.animationFrameId = requestAnimationFrame(updateProgress);
        }
      };
      requestAnimationFrame(updateProgress);
  }
  calledservice:boolean = false;
  ngOnInit() {
    if((!sessionStorage.getItem('device') || sessionStorage.getItem('device') =='Kiosk1') && (!sessionStorage.getItem('source') || sessionStorage.getItem('source') =='Kiosk1')){
      if(this.route.snapshot.queryParams['device']){
        this.device = this.route.snapshot.queryParams['device'];
      }else{
        this.device = 'Kiosk1';
      }
      if(this.route.snapshot.queryParams['source']){
        this.source = this.route.snapshot.queryParams['source'];
      }else{
        this.source = 'Kiosk1';
      }
      if(this.route.snapshot.queryParams['medium']){
        this.medium = this.route.snapshot.queryParams['medium'];
      }else{
        this.medium = 'weblink';
      }
      sessionStorage.setItem('source', this.source);
      sessionStorage.setItem('device', this.device);
      sessionStorage.setItem('medium', this.medium);
    }else{
      this.source = sessionStorage.getItem('source');
      this.device = sessionStorage.getItem('device');
      this.medium = sessionStorage.getItem('medium');
    }
    sessionStorage.removeItem('sessionId');
    this.homescreenimage = 'assets/images/Homescreenicon.png'
    const param = {
      data : 'https://m.adr.avileap.com/'
    }
    let qrimagesub;
    qrimagesub = this.apiService.getqrimage(param).subscribe((res)=>{
      this.gatesdata1 = require('../../Language/dummydata.json')
      this.gatesdata1.qrimage = res.image;
      this.gatesdata1.childdata.boarding_percentage = this.dummypercentages[0];
      this.nextgatevalue = 0;
      qrimagesub ? qrimagesub.unsubscribe() : null;
    },(error)=>{
      this.gatesdata1 = require('../../Language/dummydata.json')
      this.gatesdata1.childdata.boarding_percentage = this.dummypercentages[0];
      this.nextgatevalue = 0;
      qrimagesub ? qrimagesub.unsubscribe() : null;
    })
    this.checkOrientation();
    this.flightNo = '';
    this.languagesub = this.apiservice.language.subscribe((res)=>{
      const langcode = res.code
      this.langconfig = langcode == 'En' ? require("../../Language/En-us.json") : require("../../Language/It-us.json")
    })
      this.showvideosub = this.apiService.showvideo.subscribe(res=>{
          if(res == undefined && this.calledservice == false){
              this.apiService.showvideo.next(true);
          }else{
            if(res == false && this.calledservice == false){
              this.showvideo = false;
              this.deletetext ? this.deletetext.unsubscribe() : null;
              this.calltextfunction ? this.calltextfunction.unsubscribe() : null;
              this.charIndex = 0;
              this.isDeleting = false;
              this.autotype = true;
              this.typeAndDeleteText();
              this.calledservice = true;
              this.callinterval ? this.callinterval.unsubscribe() : null;
              this.starttimeout ? this.starttimeout.unsubscribe() : null;
              this.boadringpercentagetimer ? this.boadringpercentagetimer.unsubscribe() : null;
              this.index = 0;
              this.calltimer();
            }else if(res == true && this.calledservice == false){
                this.showvideo = true;
            }
          }
      })
      let timer1;
      timer1 = timer(15000).subscribe(()=>{
        if(this.boadringpercentagetimer){
          this.boadringpercentagetimer.unsubscribe();
        }
        this.index = 0;
        this.gatesdata1.childdata.boarding_percentage = this.dummypercentages[0];
        this.callboardingpercentage()
        if(timer1){
          timer1.unsubscribe();
        }
      });
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkOrientation();
  }

  handleValueChange(newValue: string) {
    this.flightNo = newValue;
    if(this.flightNo.length){
      this.showvideo = false;
      this.callinterval ? this.callinterval.unsubscribe() : null;
      this.calltimer();
      this.searchflightdata(this.flightNo, 'autosuggest')
    }
  }

  isOffline:boolean = false;
  private connectivitySubscription: Subscription;
  prevvalue:boolean = true;
  internetissue:Subscription;
  checkinternetissue(){
    this.internetissue = this.apiService.isoffline.subscribe(status => {
      if(status == false){
        this.showvideo = true;
        this.gateslist = [];
        if (this.animationFrameId) {
          cancelAnimationFrame(this.animationFrameId);
        }
        this.callinterval ? this.callinterval.unsubscribe() : null;
        this.callgates1 ? this.callgates1.unsubscribe() : null;
      }
      if(status == true && this.prevvalue == false){
        this.calledservice = false
        let internettimer;
        internettimer = timer(15000).subscribe(()=>{
          if(this.boadringpercentagetimer){
            this.boadringpercentagetimer.unsubscribe();
          }
          this.index = 0;
          this.gatesdata1.childdata.boarding_percentage = this.dummypercentages[0];
          this.callboardingpercentage()
          if(internettimer){
            internettimer.unsubscribe();
          }
        })
        this.nextgatevalue = 0;
        const gateslist = [];
      }
      this.prevvalue = status
      this.isOffline = status;
    });
  }

  typeAndDeleteText() {
      const currentText = this.dummyarray[this.currentIndex].text;
      if (this.isDeleting) {
        this.charIndex--;
        this.flightNo = currentText.substring(0, this.charIndex);
        this.flightNo = "Enter your " + this.flightNo
      } else {
        this.charIndex++;
        this.flightNo = currentText.substring(0, this.charIndex);
        this.flightNo = "Enter your " + this.flightNo
      }

      if (!this.isDeleting && this.charIndex === currentText.length) {
        this.deletetext = timer(1000).subscribe(() => {
          if (this.autotype) {
            this.isDeleting = true;
          }
        });
      } else if (this.isDeleting && this.charIndex === 0) {
        this.isDeleting = false;
        this.currentIndex = (this.currentIndex + 1) % this.dummyarray.length;
      }

      const speed = this.isDeleting ? 100 : 150;
      this.calltextfunction = timer(speed).subscribe(() => this.typeAndDeleteText());
  }

  makevaluenull(){
    this.showkeyboard = true;
    if(this.autotype == true){
      this.deletetext ? this.deletetext.unsubscribe() : null;
      this.calltextfunction ? this.calltextfunction.unsubscribe() : null;
      this.autotype = false;
      this.flightNo = '';
    }
  }

  inputclicked(event: MouseEvent) {
    if(this.autotype == false){
      this.gsearch = true;
      const inputElement = this.inputElementRef.nativeElement as HTMLInputElement;
      const cursorPosition = inputElement.selectionStart;
      this.cursorPosition = cursorPosition;
    }
  }


  hidekeyboard(event){
    this.showkeyboard = event;
  }
  

  private checkOrientation(): void {
    this.isPortrait = window.innerHeight > window.innerWidth ? true : false;
  }

  closedialog(){
    this.ref.close();
  }
  calltimer(){
    this.i = 0
    this.calltimer1 ? this.calltimer1.unsubscribe() : null;
    this.calltimer2 ? this.calltimer2.unsubscribe() : null
    this.calltimer1 = timer(30000).subscribe(()=>{
      this.deletetext ? this.deletetext.unsubscribe() : null;
      this.calltextfunction ? this.calltextfunction.unsubscribe() : null;
      this.showvideo = true;
      this.flightNo = '';
      this.calledservice = false;
      this.calltimer2 = timer(15000).subscribe(()=>{
        if(this.boadringpercentagetimer){
          this.boadringpercentagetimer.unsubscribe();
        }
        this.gatesdata1 = require('../../Language/dummydata.json');
        this.index = 0;
        this.gatesdata1.childdata.boarding_percentage = this.dummypercentages[0];
        this.callboardingpercentage();
      });
    });
  }

  boadringpercentagetimer;
  callboardingpercentage(){
    let timer2;
    if(this.boadringpercentagetimer){
      this.boadringpercentagetimer.unsubscribe();
      timer2 ? timer2.unsubscribe() : null;
      this.gatesdata1.childdata.boarding_percentage = this.dummypercentages[0];
      this.index = 0;
    }
    this.startProgress();
     timer2 = this.boadringpercentagetimer = timer(0, 5000).subscribe(()=>{ // runs every 5 seconds
      if(this.index < 3){
        this.gatesdata1.childdata.boarding_percentage = this.dummypercentages[this.index];
        this.index++
      }else{
        if(this.boadringpercentagetimer){
          this.boadringpercentagetimer.unsubscribe();
        }
        this.gatesdata1.childdata.boarding_percentage = this.dummypercentages[0];
        this.index = 0;
        let timer1 = timer(15000).subscribe(()=>{
          this.callboardingpercentage();
          timer1 ? timer1.unsubscribe() : null;
        })
      }
    });              
  }

  i = 0;
  showkeyboard:boolean = false;
  onclick(){
    this.apiService.showvideo.next(false);
  }

  sendToPNR2() {
    if(this.flightNo && !this.autotype && !this.nodatamessage){
      this.flightNo = this.flightNo.toUpperCase()
      this.spinner = true;
      let gatesapi;
      gatesapi = this.apiService.gates_api(this.flightNo).subscribe(response => {
          this.flightNo = response.data[0].gate_no
          let responsedata = response.data.filter(item => item !== response.data[1])
            this.apiService.setSharedData(responsedata);
            this.opengate(this.flightNo);
            gatesapi ? gatesapi.unsubscribe() : null;
      },(error)=>{
          this.spinner = false;
          this.opendialogbox()
          gatesapi ? gatesapi.unsubscribe() : null;

        })      
    }
  }

  opengate(d, a?){
    if(!a){
      this.gsearch = false;
      const devicedetails = this.devicedetails.getDeviceInfo();
      const deviceres = window.innerHeight + '*' + window.innerWidth;
      const devicetype = this.devicedetails.isTablet() ? 'Tablet' : this.devicedetails.isMobile() ? 'Mobile' : this.devicedetails.isDesktop() ? 'Desktop' : 'Others';
      const param = {
        browser_name : devicedetails.browser,
        browser_version: devicedetails.browser_version,
        device_name: devicedetails.device,
        os_name: devicedetails.os,
        os_version: devicedetails.os_version,
        user_agent: devicedetails.userAgent,
        resolution: deviceres,
        device_type: devicetype,
        gate : d,
        device: this.device ? this.device : 'Undefined',
        source: this.source ? this.source : 'Undefined',
        medium: this.medium ? this.medium : 'Undefined',
      }
      this.spinner = true;
      let gatesapi;
      gatesapi = this.apiService.gates_api(d).subscribe(response => {
            this.flightNo = response.data[0].gate_no
            let responsedata = response.data.filter(item => item !== response.data[1])
              this.apiService.setSharedData(responsedata);
              let sessionsub;
              sessionsub = this.apiService.getsession(param).subscribe(res =>{
                  if(res.id){
                    this.sessionid = res.id
                    this.spinner = false;
                    this.flightNo = d;
                    this.router.navigate(['/pax'],{ queryParams: { gateno: d, pax_view_session: this.sessionid } })
                    this.apiService.setsessionId('sessionId', this.sessionid,2);
                  }
                  this.spinner = false;
                  sessionsub ? sessionsub.unsubscribe() : null;
                },(error)=>{
                  sessionsub ? sessionsub.unsubscribe() : null;
                  this.spinner = false;
                })
              gatesapi ? gatesapi.unsubscribe() : null;
          },(error)=>{
            this.apiService.showvideo.next(false);
            this.spinner = false;
            this.opendialogbox()
            gatesapi ? gatesapi.unsubscribe() : null;
      })   
    }else{
      this.flightNo = d;
      this.lastInput = this.flightNo;
      this.cursorPosition = this.flightNo.length
      this.apiservice.cursorposition.next(this.cursorPosition);
      this.searchflightdata(this.flightNo);
    }
  }

  gsearch:boolean = false;
  gatenotassigned:boolean = false;
  searchflightdata(fdata, a?){
    this.gatenotassigned = false
    if(a){
      this.apiService.showvideo.next(false);
      this.nodatamessage = false;
      this.dataarray = [];
      const flightdata = fdata.toUpperCase()
      if(fdata.length >0){
        this.SearchLoader = true;
        this.gsearch = true;
        this.apiTrigger$
        .pipe(
          switchMap(flightdata => this.apiService.Autosearchapi(flightdata)),
          takeUntil(this.userStop$)).subscribe(
          response => {
            this.apiService.showvideo.next(false);
            this.dataarray = [];
            this.nodatamessage = response.data.length > 0 ? false : true;
            const cutoffdata = response.data.slice(0, 10);
            this.dataarray = cutoffdata;
            this.SearchLoader = false;
          },
          error => {
            this.apiService.showvideo.next(false);
            this.nodatamessage = true;
            this.SearchLoader = false;
          },
          () => {
            this.userStop$.next(true);
          }
        );
        this.apiTrigger$.next(flightdata);
      }
    }else{
      if(this.dataarray.length >0){
        this.apiService.showvideo.next(false);
        this.nodatamessage = false;
        this.allflightdata = [];
        const flightdata = fdata.toUpperCase()
          this.SearchLoader = true;
          this.gsearch = false
          let clickserachapi;
          clickserachapi = this.apiService.clicksearchapi(flightdata).subscribe(response => {
            this.apiService.showvideo.next(false);
            this.nodatamessage = response.data.length > 0 ? false : true;
            this.dataarray = [];
            this.allflightdata = response.data;
            this.SearchLoader = false;
            this.userStop$.next(true);
            clickserachapi ? clickserachapi.unsubscribe() : null;
          },(error)=>{
            this.apiService.showvideo.next(false);
            this.userStop$.next(true);
            this.gsearch = false;
            this.nodatamessage = true;
            this.SearchLoader = false;
            clickserachapi ? clickserachapi.unsubscribe() : null;
          })
      }
    }
  }

  opendialogbox(){
    // this.ref = this.dialog.open(this.DialogComponent);
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    if (this.connectivitySubscription) {
      this.connectivitySubscription.unsubscribe();
    }
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
    this.calltextfunction ? this.calltextfunction.unsubscribe() : null;
    this.deletetext ? this.deletetext.unsubscribe() : null;
    this.languagesub ? this.languagesub.unsubscribe() : null;
    this.internetissue ? this.internetissue.unsubscribe() : null;
    this.callinterval ? this.callinterval.unsubscribe() : null;
    this.callgates1 ? this.callgates1.unsubscribe() : null;
    this.calltimer2 ? this.calltimer2.unsubscribe() : null;
  }
}
